<div
  [class]="'animated fadeIn card ' + andClass"
  [class.card-dense]="dense"
  [class.card-small]="small"
  [class.card-list]="cardList || cardMainList"
  [class.card-main-list]="cardMainList"
  [id]="id ? id : null">
  <ng-content></ng-content>
</div>
